import { IBooking } from 'src/app/models';
import { IBookingsState, IPagination } from '../states';

export const initialBookingsState: IBookingsState = {
  value: [] as IBooking[],
  isFetchingBookings: true,
  pagination: {} as IPagination,
};
